export default "__VITE_ASSET__BAvYz0BS__"